import { proNavigator } from "single-spa/react-app/ProNavigator";
import { translate } from "app/filters/i18nFilter";
import { AssetAddedModal } from "app/components/modals/components/AssetAddedModal";
import type { IDashboard } from "app/components/dashboard/services/IDashboard";
import { setLocalDashboardData } from "app/pages/dashboard/components/NavigationHeader/ProjectDashboardHelper";

interface IDashboardAddedModalProps {
    dashboard: IDashboard;
    isOpen: boolean;
    onClose?: () => void;
}

export const DashboardAddedModal: React.FC<IDashboardAddedModalProps> = ({ dashboard, isOpen, onClose }) => {
    return (
        <AssetAddedModal
            isOpen={isOpen}
            title={translate("project.preview.DashboardAddedModal.title")}
            buttonText={translate("project.preview.DashboardAddedModal.button")}
            onClick={() => {
                onClose?.();
                setLocalDashboardData(dashboard.title);
                proNavigator.go("dashboard-exist", { dashboardId: dashboard.id });
            }}
            onClose={onClose}
        />
    );
};
